import { loadBrandingTheme } from "./themes";

const PORTAL_BRAND_CACHE_KEY = "portal_brand";

export const resolveTheme = async (brandId, tenantSvc, mode = "light") => {
  const tenantId = tenantSvc?.tenantId;

  // Priority: brandId > tenantId > localStorage cache > default
  // 1. Try to load theme by brandId first (if provided and not empty)
  if (brandId) {
    try {
      const theme = await loadBrandingTheme(brandId, mode);
      // Cache the successfully resolved brandId
      localStorage.setItem(PORTAL_BRAND_CACHE_KEY, brandId);
      return theme;
    } catch (error) {
      // Brand theme not available, continue to tenantId
    }
  }

  // 2. Try to load theme by tenantId if brandId failed or not provided
  if (tenantId) {
    try {
      const theme = await loadBrandingTheme(tenantId, mode);
      // Cache the successfully resolved tenantId
      localStorage.setItem(PORTAL_BRAND_CACHE_KEY, tenantId);
      return theme;
    } catch (error) {
      // Tenant theme not available, continue to localStorage cache
    }
  }

  // 3. Fallback to default theme
  const theme = await loadBrandingTheme("default", mode);
  return theme;
};
